import React, { useState, useEffect } from 'react';
import { ReactSVG } from 'react-svg';
import { CustomButton, Modal, InputBox } from 'ui-controls';
import { PhoneCall } from 'assets';
import Select from 'react-select';
import {
  useAddCompanyMutation,
  useGetListCompanyQuery,
} from 'services/rtkQueries';
import { toast } from 'react-toastify';
import { useModalStack } from './ModalStackProvider';

const TYPE_OPTIONS = [
  { value: 'Fund Manager', label: 'Fund Manager' },
  { value: 'Investment', label: 'Investment' },
  { value: 'Pension Fund', label: 'Pension Fund' },
  { value: 'Wealth Management', label: 'Wealth Management' },
  { value: 'Endowment', label: 'Endowment' },
  { value: 'Limited Partner', label: 'Limited Partner' },
];

const INITIAL_FORM_VALUES = {
  company_name: '',
  company_type: {},
  company_desc: '',
  company_sector: '',
  year_established: {},
};

const AddCompanyModal = ({ isModalOpen, afterCompanyAdded = () => {} }) => {
  const [formValues, setFormValues] = useState(INITIAL_FORM_VALUES);
  const { pushModal, popModal } = useModalStack();
  const [addCompany, { isLoading, isError, isSuccess }] =
    useAddCompanyMutation();

  // Map companies to options
  const selectYearOptions = [...Array(60)].map((_, i) => ({
    value: i + 1980,
    label: i + 1980,
  }));

  // Handle form input changes
  const handleInputChange = (field, value) => {
    setFormValues((prev) => ({ ...prev, [field]: value }));
  };

  // Handle form submission
  const handleSubmit = async () => {
    if (!formValues.company_name || !formValues.company_type?.value) {
      toast.error('Company Name and Type fields are required.');
      return;
    }

    try {
      const payload = {
        ...formValues,
        year_established: formValues.year_established?.value || null,
        company_type: formValues.company_type?.value || null,
      };

      const res = await addCompany(payload).unwrap(); // unwrap gives direct payload
      const newCompany = res?.data;
      const contactObj = {};
      if (newCompany) {
        contactObj.id = newCompany.company_id;
        contactObj.label = newCompany.company_name;
        contactObj.value = newCompany.company_name;
      }

      toast.success(res?.message || 'Company added successfully');
      setFormValues(INITIAL_FORM_VALUES);
      afterCompanyAdded(contactObj);
      popModal(); // close modal
    } catch (error) {
      toast.error(
        error?.data?.message || 'An error occurred while adding the company.'
      );
      console.error(error);
    }
  };

  return (
    <div className="reference-modal">
      <Modal
        isModalOpen={isModalOpen}
        title="Add Company"
        Icon={<ReactSVG src={PhoneCall} alt="" className="menuIcon" />}
        onClose={popModal}
        style={{
          content: {
            width: '60em',
            height: '45em',
            inset: '50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: '15px',
            overflow: 'auto',
          },
        }}
      >
        <div className="">
          <div className="form-field">
            <InputBox
              label="Company Name:"
              value={formValues.company_name}
              placeholder="Enter Company Name"
              onChange={(event) =>
                handleInputChange('company_name', event.target.value)
              }
            />
          </div>
          <div className="form-field">
            <div className="label">Company Type:</div>
            <Select
              value={formValues.type}
              classNamePrefix="react-select-custom"
              options={TYPE_OPTIONS}
              placeholder="Select Company Type"
              isSearchable
              onChange={(value) => handleInputChange('company_type', value)}
            />
          </div>
          <div className="form-field">
            <InputBox
              label="Company Desc:"
              value={formValues.company_desc}
              placeholder="Enter Company Description"
              onChange={(event) =>
                handleInputChange('company_desc', event.target.value)
              }
            />
          </div>
          <div className="form-field">
            <InputBox
              label="Company Sector:"
              value={formValues.company_sector}
              placeholder="Enter Company Sector"
              onChange={(event) =>
                handleInputChange('company_sector', event.target.value)
              }
            />
          </div>
          <div className="form-field">
            <div className="label">Year Established:</div>
            <Select
              value={formValues.type}
              classNamePrefix="react-select-custom"
              options={selectYearOptions}
              placeholder="Select Year Established"
              isSearchable
              onChange={(value) => handleInputChange('year_established', value)}
            />
          </div>
          <div className="emptySpaceVertical"></div>
          <div className="d-flex justify-content-end">
            <CustomButton
              name="Cancel"
              className="editBtn mx-2 review-cancel"
              onClick={popModal}
            />
            <CustomButton
              name="Save"
              className="footerPrimaryBtn submit-email mx-2"
              onClick={handleSubmit}
              disabled={isLoading}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default AddCompanyModal;
